import {UnlockChoiceEntryPoint} from "./UnlockChoiceEntryPoint";

export enum RegistrationWizardAccountEntry {
    SIGN_UP = "sign_up",
    FAVOURITE = "favourite",
    NOTIFICATIONS = "notifications",
    AI_ASSISTANT = "ai_assistant",
    ARTICLE_COMMENT = "article_comment",
    LEAD_INQUIRY = "lead_inquiry",
    OFFER_PRICE = "offer_price"
}

export type RegistrationWizardEntry = UnlockChoiceEntryPoint | RegistrationWizardAccountEntry;

export type RegistrationAuthMode = "registration" | "login";
import {UnlockChoiceEntryPoint} from "./UnlockChoiceEntryPoint";

export enum RegistrationWizardAccountEntry {
    SIGN_UP = "sign_up",
    FAVOURITE = "favourite",
    NOTIFICATIONS = "notifications",
    AI_ASSISTANT = "ai_assistant",
    ARTICLE_COMMENT = "article_comment",
    LEAD_INQUIRY = "lead_inquiry",
    OFFER_PRICE = "offer_price"
}

export type RegistrationWizardEntry = UnlockChoiceEntryPoint | RegistrationWizardAccountEntry;

export type RegistrationAuthMode = "registration" | "login";
